import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';

import { apiGetMe } from 'core/api';
import { useMessageModal } from 'core/ui/MessageModal';

const context = createContext<TWithMeContext>(null);
context.displayName = 'WithMe';

type TWithMeContext = TUser | null;

export function WithMeProvider({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<TUser | null>(null);
  const { showError } = useMessageModal();

  useEffect(() => {
    apiGetMe().then(setMe).catch(showError);
  }, []);

  return <context.Provider value={me}>{children}</context.Provider>;
}

export function useMe() {
  return useContext(context);
}
